/** ERC-7540 async-redeem surface — `pendingRedeemRequest` /
 *  `claimableRedeemRequest`. Used by Hyperbeat hbHYPE Ultra and any
 *  other 7540-compliant vault.
 *
 *  Note: EIP-7540 has no native enumeration. Consumers either:
 *   - Use `requestId = 0` when the vault has a single-pending-request
 *     shape (common simplification), or
 *   - Index `RedeemRequest` events off-chain to discover requestIds.
 *  This reader uses the `requestId = 0` shortcut. */
export const Erc7540Abi = [
  {
    name: 'pendingRedeemRequest',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'uint256', name: 'requestId' },
      { type: 'address', name: 'controller' },
    ],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'claimableRedeemRequest',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'uint256', name: 'requestId' },
      { type: 'address', name: 'controller' },
    ],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'convertToAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'shares' }],
    outputs: [{ type: 'uint256' }],
  },
] as const
